import { UserType } from "./types/user.types";

const setToken = (token: string) => {
  localStorage.setItem("token", token);
};
const getToken = () => {
  return localStorage.getItem("token");
};

const removeToken = () => {
  localStorage.removeItem("token");
};

const setUser = (user: UserType) => {
  localStorage.setItem("user", JSON.stringify(user));
};

const getUser = () => {
  const user = localStorage.getItem("user");
  if (user) {
    try {
      return JSON.parse(user) as UserType;
    } catch (_error) {
      localStorage.removeItem("user");
    }
  }
  return null;
};

const removeUser = () => {
  localStorage.removeItem("user");
};

const clearAuthStorage = () => {
  removeToken();
  removeUser();
};

export {
  clearAuthStorage,
  getToken,
  getUser,
  removeToken,
  removeUser,
  setToken,
  setUser,
};
